import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./login";
import Register from "./register";
import Emaillog from "./Emaillog";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/Emaillog" element={<Emaillog />} />
      </Routes>
    </Router>
  );
}

export default App;

